/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const InventoryRequestDTODecisionEnum = {
    Saleable: 'SALEABLE',
    Recheck: 'RECHECK',
    Unsaleable: 'UNSALEABLE'
};
/**
 * @export
 */
export const InventoryRequestDTOInventoryStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Incomplete: 'INCOMPLETE',
    Creating: 'CREATING',
    Deleting: 'DELETING'
};
/**
 * @export
 */
export const InventoryRequestDTOMerchantTypeEnum = {
    Fba: 'FBA',
    Fbm: 'FBM',
    Sba: 'SBA'
};
/**
 * @export
 */
export const InventoryRequestDTOTargetChineseSellerEnum = {
    Has: 'HAS',
    None: 'NONE'
};
/**
 * @export
 */
export const InventoryRequestDTOMatchModeEnum = {
    All: 'ALL',
    Any: 'ANY'
};
/**
 * Check if a given object implements the InventoryRequestDTO interface.
 */
export function instanceOfInventoryRequestDTO(value) {
    return true;
}
export function InventoryRequestDTOFromJSON(json) {
    return InventoryRequestDTOFromJSONTyped(json, false);
}
export function InventoryRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'decision': json['decision'] == null ? undefined : json['decision'],
        'keyword': json['keyword'] == null ? undefined : json['keyword'],
        'inventoryStatus': json['inventoryStatus'] == null ? undefined : json['inventoryStatus'],
        'purchasePriceUsdMin': json['purchasePriceUsdMin'] == null ? undefined : json['purchasePriceUsdMin'],
        'purchasePriceUsdMax': json['purchasePriceUsdMax'] == null ? undefined : json['purchasePriceUsdMax'],
        'shippingPriceUsdMin': json['shippingPriceUsdMin'] == null ? undefined : json['shippingPriceUsdMin'],
        'shippingPriceUsdMax': json['shippingPriceUsdMax'] == null ? undefined : json['shippingPriceUsdMax'],
        'sourceCategoryBsrMin': json['sourceCategoryBsrMin'] == null ? undefined : json['sourceCategoryBsrMin'],
        'sourceCategoryBsrMax': json['sourceCategoryBsrMax'] == null ? undefined : json['sourceCategoryBsrMax'],
        'sourceSubcategoryBsrMin': json['sourceSubcategoryBsrMin'] == null ? undefined : json['sourceSubcategoryBsrMin'],
        'sourceSubcategoryBsrMax': json['sourceSubcategoryBsrMax'] == null ? undefined : json['sourceSubcategoryBsrMax'],
        'sourceReviewMin': json['sourceReviewMin'] == null ? undefined : json['sourceReviewMin'],
        'sourceReviewMax': json['sourceReviewMax'] == null ? undefined : json['sourceReviewMax'],
        'sourceReviewRatingMin': json['sourceReviewRatingMin'] == null ? undefined : json['sourceReviewRatingMin'],
        'sourceReviewRatingMax': json['sourceReviewRatingMax'] == null ? undefined : json['sourceReviewRatingMax'],
        'sourceBoughtPastMonthMin': json['sourceBoughtPastMonthMin'] == null ? undefined : json['sourceBoughtPastMonthMin'],
        'sourceBoughtPastMonthMax': json['sourceBoughtPastMonthMax'] == null ? undefined : json['sourceBoughtPastMonthMax'],
        'sourceRootCategory': json['sourceRootCategory'] == null ? undefined : json['sourceRootCategory'],
        'merchantType': json['merchantType'] == null ? undefined : json['merchantType'],
        'availability': json['availability'] == null ? undefined : json['availability'],
        'isBestSeller': json['isBestSeller'] == null ? undefined : json['isBestSeller'],
        'sourceShippingPriceUsdMin': json['sourceShippingPriceUsdMin'] == null ? undefined : json['sourceShippingPriceUsdMin'],
        'sourceShippingPriceUsdMax': json['sourceShippingPriceUsdMax'] == null ? undefined : json['sourceShippingPriceUsdMax'],
        'sourceTotalOfferCountMin': json['sourceTotalOfferCountMin'] == null ? undefined : json['sourceTotalOfferCountMin'],
        'sourceTotalOfferCountMax': json['sourceTotalOfferCountMax'] == null ? undefined : json['sourceTotalOfferCountMax'],
        'sourcePrimeOfferCountMin': json['sourcePrimeOfferCountMin'] == null ? undefined : json['sourcePrimeOfferCountMin'],
        'sourcePrimeOfferCountMax': json['sourcePrimeOfferCountMax'] == null ? undefined : json['sourcePrimeOfferCountMax'],
        'deliveryPromiseDaysMin': json['deliveryPromiseDaysMin'] == null ? undefined : json['deliveryPromiseDaysMin'],
        'deliveryPromiseDaysMax': json['deliveryPromiseDaysMax'] == null ? undefined : json['deliveryPromiseDaysMax'],
        'returnable': json['returnable'] == null ? undefined : json['returnable'],
        'freeReturns': json['freeReturns'] == null ? undefined : json['freeReturns'],
        'amazonsChoice': json['amazonsChoice'] == null ? undefined : json['amazonsChoice'],
        'primeExclusive': json['primeExclusive'] == null ? undefined : json['primeExclusive'],
        'voltageMin': json['voltageMin'] == null ? undefined : json['voltageMin'],
        'voltageMax': json['voltageMax'] == null ? undefined : json['voltageMax'],
        'bulbBase': json['bulbBase'] == null ? undefined : json['bulbBase'],
        'powerSource': json['powerSource'] == null ? undefined : json['powerSource'],
        'sourceSalesRank': json['sourceSalesRank'] == null ? undefined : json['sourceSalesRank'],
        'targetSalesRank': json['targetSalesRank'] == null ? undefined : json['targetSalesRank'],
        'targetCategoryBsrMin': json['targetCategoryBsrMin'] == null ? undefined : json['targetCategoryBsrMin'],
        'targetCategoryBsrMax': json['targetCategoryBsrMax'] == null ? undefined : json['targetCategoryBsrMax'],
        'targetSubcategoryBsrMin': json['targetSubcategoryBsrMin'] == null ? undefined : json['targetSubcategoryBsrMin'],
        'targetSubcategoryBsrMax': json['targetSubcategoryBsrMax'] == null ? undefined : json['targetSubcategoryBsrMax'],
        'totalOfferCountMin': json['totalOfferCountMin'] == null ? undefined : json['totalOfferCountMin'],
        'totalOfferCountMax': json['totalOfferCountMax'] == null ? undefined : json['totalOfferCountMax'],
        'targetReviewRatingMin': json['targetReviewRatingMin'] == null ? undefined : json['targetReviewRatingMin'],
        'targetReviewRatingMax': json['targetReviewRatingMax'] == null ? undefined : json['targetReviewRatingMax'],
        'targetReviewMin': json['targetReviewMin'] == null ? undefined : json['targetReviewMin'],
        'targetReviewMax': json['targetReviewMax'] == null ? undefined : json['targetReviewMax'],
        'targetHasPrimeOffer': json['targetHasPrimeOffer'] == null ? undefined : json['targetHasPrimeOffer'],
        'targetHasBuybox': json['targetHasBuybox'] == null ? undefined : json['targetHasBuybox'],
        'targetHasAmazonSeller': json['targetHasAmazonSeller'] == null ? undefined : json['targetHasAmazonSeller'],
        'targetHasFBASeller': json['targetHasFBASeller'] == null ? undefined : json['targetHasFBASeller'],
        'sourceBuyboxSellerChinese': json['sourceBuyboxSellerChinese'] == null ? undefined : json['sourceBuyboxSellerChinese'],
        'sourceBrandAndSellerSame': json['sourceBrandAndSellerSame'] == null ? undefined : json['sourceBrandAndSellerSame'],
        'targetChineseSeller': json['targetChineseSeller'] == null ? undefined : json['targetChineseSeller'],
        'targetBrandSeller': json['targetBrandSeller'] == null ? undefined : json['targetBrandSeller'],
        'sellingPriceMin': json['sellingPriceMin'] == null ? undefined : json['sellingPriceMin'],
        'sellingPriceMax': json['sellingPriceMax'] == null ? undefined : json['sellingPriceMax'],
        'totalCostUsdMin': json['totalCostUsdMin'] == null ? undefined : json['totalCostUsdMin'],
        'totalCostUsdMax': json['totalCostUsdMax'] == null ? undefined : json['totalCostUsdMax'],
        'profitUsdMin': json['profitUsdMin'] == null ? undefined : json['profitUsdMin'],
        'profitUsdMax': json['profitUsdMax'] == null ? undefined : json['profitUsdMax'],
        'minProfitUsdMin': json['minProfitUsdMin'] == null ? undefined : json['minProfitUsdMin'],
        'minProfitUsdMax': json['minProfitUsdMax'] == null ? undefined : json['minProfitUsdMax'],
        'priceDiffBuyboxMin': json['priceDiffBuyboxMin'] == null ? undefined : json['priceDiffBuyboxMin'],
        'priceDiffBuyboxMax': json['priceDiffBuyboxMax'] == null ? undefined : json['priceDiffBuyboxMax'],
        'priceDiffLowestMin': json['priceDiffLowestMin'] == null ? undefined : json['priceDiffLowestMin'],
        'priceDiffLowestMax': json['priceDiffLowestMax'] == null ? undefined : json['priceDiffLowestMax'],
        'isPriceBelowBuybox': json['isPriceBelowBuybox'] == null ? undefined : json['isPriceBelowBuybox'],
        'isPricedBelowMin': json['isPricedBelowMin'] == null ? undefined : json['isPricedBelowMin'],
        'amIBuybox': json['amIBuybox'] == null ? undefined : json['amIBuybox'],
        'profitPercentMin': json['profitPercentMin'] == null ? undefined : json['profitPercentMin'],
        'profitPercentMax': json['profitPercentMax'] == null ? undefined : json['profitPercentMax'],
        'previouslySold': json['previouslySold'] == null ? undefined : json['previouslySold'],
        'createdDateFrom': json['createdDateFrom'] == null ? undefined : (new Date(json['createdDateFrom'])),
        'createdDateTo': json['createdDateTo'] == null ? undefined : (new Date(json['createdDateTo'])),
        'pendingDeletion': json['pendingDeletion'] == null ? undefined : json['pendingDeletion'],
        'matchMode': json['matchMode'] == null ? undefined : json['matchMode'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
    };
}
export function InventoryRequestDTOToJSON(json) {
    return InventoryRequestDTOToJSONTyped(json, false);
}
export function InventoryRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'decision': value['decision'],
        'keyword': value['keyword'],
        'inventoryStatus': value['inventoryStatus'],
        'purchasePriceUsdMin': value['purchasePriceUsdMin'],
        'purchasePriceUsdMax': value['purchasePriceUsdMax'],
        'shippingPriceUsdMin': value['shippingPriceUsdMin'],
        'shippingPriceUsdMax': value['shippingPriceUsdMax'],
        'sourceCategoryBsrMin': value['sourceCategoryBsrMin'],
        'sourceCategoryBsrMax': value['sourceCategoryBsrMax'],
        'sourceSubcategoryBsrMin': value['sourceSubcategoryBsrMin'],
        'sourceSubcategoryBsrMax': value['sourceSubcategoryBsrMax'],
        'sourceReviewMin': value['sourceReviewMin'],
        'sourceReviewMax': value['sourceReviewMax'],
        'sourceReviewRatingMin': value['sourceReviewRatingMin'],
        'sourceReviewRatingMax': value['sourceReviewRatingMax'],
        'sourceBoughtPastMonthMin': value['sourceBoughtPastMonthMin'],
        'sourceBoughtPastMonthMax': value['sourceBoughtPastMonthMax'],
        'sourceRootCategory': value['sourceRootCategory'],
        'merchantType': value['merchantType'],
        'availability': value['availability'],
        'isBestSeller': value['isBestSeller'],
        'sourceShippingPriceUsdMin': value['sourceShippingPriceUsdMin'],
        'sourceShippingPriceUsdMax': value['sourceShippingPriceUsdMax'],
        'sourceTotalOfferCountMin': value['sourceTotalOfferCountMin'],
        'sourceTotalOfferCountMax': value['sourceTotalOfferCountMax'],
        'sourcePrimeOfferCountMin': value['sourcePrimeOfferCountMin'],
        'sourcePrimeOfferCountMax': value['sourcePrimeOfferCountMax'],
        'deliveryPromiseDaysMin': value['deliveryPromiseDaysMin'],
        'deliveryPromiseDaysMax': value['deliveryPromiseDaysMax'],
        'returnable': value['returnable'],
        'freeReturns': value['freeReturns'],
        'amazonsChoice': value['amazonsChoice'],
        'primeExclusive': value['primeExclusive'],
        'voltageMin': value['voltageMin'],
        'voltageMax': value['voltageMax'],
        'bulbBase': value['bulbBase'],
        'powerSource': value['powerSource'],
        'sourceSalesRank': value['sourceSalesRank'],
        'targetSalesRank': value['targetSalesRank'],
        'targetCategoryBsrMin': value['targetCategoryBsrMin'],
        'targetCategoryBsrMax': value['targetCategoryBsrMax'],
        'targetSubcategoryBsrMin': value['targetSubcategoryBsrMin'],
        'targetSubcategoryBsrMax': value['targetSubcategoryBsrMax'],
        'totalOfferCountMin': value['totalOfferCountMin'],
        'totalOfferCountMax': value['totalOfferCountMax'],
        'targetReviewRatingMin': value['targetReviewRatingMin'],
        'targetReviewRatingMax': value['targetReviewRatingMax'],
        'targetReviewMin': value['targetReviewMin'],
        'targetReviewMax': value['targetReviewMax'],
        'targetHasPrimeOffer': value['targetHasPrimeOffer'],
        'targetHasBuybox': value['targetHasBuybox'],
        'targetHasAmazonSeller': value['targetHasAmazonSeller'],
        'targetHasFBASeller': value['targetHasFBASeller'],
        'sourceBuyboxSellerChinese': value['sourceBuyboxSellerChinese'],
        'sourceBrandAndSellerSame': value['sourceBrandAndSellerSame'],
        'targetChineseSeller': value['targetChineseSeller'],
        'targetBrandSeller': value['targetBrandSeller'],
        'sellingPriceMin': value['sellingPriceMin'],
        'sellingPriceMax': value['sellingPriceMax'],
        'totalCostUsdMin': value['totalCostUsdMin'],
        'totalCostUsdMax': value['totalCostUsdMax'],
        'profitUsdMin': value['profitUsdMin'],
        'profitUsdMax': value['profitUsdMax'],
        'minProfitUsdMin': value['minProfitUsdMin'],
        'minProfitUsdMax': value['minProfitUsdMax'],
        'priceDiffBuyboxMin': value['priceDiffBuyboxMin'],
        'priceDiffBuyboxMax': value['priceDiffBuyboxMax'],
        'priceDiffLowestMin': value['priceDiffLowestMin'],
        'priceDiffLowestMax': value['priceDiffLowestMax'],
        'isPriceBelowBuybox': value['isPriceBelowBuybox'],
        'isPricedBelowMin': value['isPricedBelowMin'],
        'amIBuybox': value['amIBuybox'],
        'profitPercentMin': value['profitPercentMin'],
        'profitPercentMax': value['profitPercentMax'],
        'previouslySold': value['previouslySold'],
        'createdDateFrom': value['createdDateFrom'] == null ? undefined : ((value['createdDateFrom']).toISOString()),
        'createdDateTo': value['createdDateTo'] == null ? undefined : ((value['createdDateTo']).toISOString()),
        'pendingDeletion': value['pendingDeletion'],
        'matchMode': value['matchMode'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'createdBy': value['createdBy'],
    };
}
